// PROD-2743 · one table recipe for every Patient chart sub-tab, with the `frameV2` switch ON
// (Samer's review, 1 Oct, item 4: "Correct layout dimensions and responsive spacing across all
// Patient Chart sub-tabs … Fix the column width and padding in the 'Active medications' and 'Past
// medications' data tables … consistent container widths and … table typography").
//
// The chart tabs render inside the encounter's centre column (Patient chart workspace tab), which
// can be as narrow as the note's 560px minimum. Today every chart table sits in an
// `overflow-hidden` card, so a table wider than the column (Medications has ten columns) loses its
// right-hand columns, and its header and cells use an ad-hoc 11px caps recipe. ON:
//   - the card keeps the column's width and the TABLE scrolls inside it (no column is clipped and the
//     chart column itself never widens), with the card border + resting shadow-2;
//   - header cells are the DS caps eyebrow (12 bold, section-heading tracking, text-secondary) and
//     never wrap; body cells are DS body (13, text-primary); a short value (a date, a dose, a count)
//     never breaks mid-value; padding stays px-3 py-2 on every tab.
// OFF returns today's classes unchanged, character for character.
import { cn } from '@scripsteam/scrips-signal-ds';
import { V2_BODY, V2_CARD_EDGE, V2_EYEBROW, isFrameV2 } from '@/shared/ui/design-v2';

/** What a chart table's column holds. The bridge sizes columns by it (`data-chart-cell` on the cell): `index` (#),
 *  `name` (the thing the row is about: the room goes here, two lines at most), `text` (a wrapping value), `short` (a
 *  compact value on one line), `date`, `note` (one line, cut with an ellipsis, the full text in the instant tooltip),
 *  `actions` (the row's icon buttons). */
export type ChartCell = 'index' | 'name' | 'text' | 'short' | 'date' | 'note' | 'actions';

export const CHART_TH_V2 = cn(V2_EYEBROW, 'whitespace-nowrap');
export const CHART_TD_V2 = V2_BODY;
export const CHART_TD_NOWRAP_V2 = cn(V2_BODY, 'whitespace-nowrap');
/** The value column that names the thing (a medication, a vaccine): wide enough to read. */
export const CHART_TD_WIDE_V2 = cn(V2_BODY, 'min-w-40');

/** A chart table's card: `today` OFF; ON the card edge, and horizontal scroll instead of a clip. */
export function chartTableCard(today: string): string {
  if (!isFrameV2()) return today;
  const kept = today
    .split(' ')
    .filter((c) => c !== 'overflow-hidden')
    .join(' ');
  return cn(kept, V2_CARD_EDGE, 'overflow-x-auto');
}

/** A chart header / body cell: `today` OFF; ON the DS role merged over it (padding and alignment kept). */
export function chartCell(today: string, v2: string): string {
  return isFrameV2() ? cn(today, v2) : today;
}
